import React from "react";
import { DesignElementView } from "./DesignElementView";
import { markingEffect } from "../../utils/markingEffect";
import type { DesignElement, ElementPatch, MarkingId, MockupDef, MockupView } from "../../types/configurator";
interface DesignLayerProps {
  mockup: MockupDef;
  view: MockupView;
  elements: DesignElement[];
  markingId: MarkingId | null;
  productHex: string;
  interactive?: boolean;
  activeZoneId?: string | null;
  selectedId?: string | null;
  onZoneClick?: (zoneId: string) => void;
  onSelect?: (el: DesignElement) => void;
  onLive?: (id: string, patch: ElementPatch) => void;
  onCommit?: (id: string, patch: ElementPatch) => void;
  onGestureStart?: () => void;
  onGestureEnd?: () => void;
  onDelete?: (id: string) => void;
}
export function DesignLayer({
  mockup,
  view,
  elements,
  markingId,
  productHex,
  interactive = false,
  activeZoneId = null,
  selectedId = null,
  onZoneClick,
  onSelect,
  onLive,
  onCommit,
  onGestureStart,
  onGestureEnd,
  onDelete
}: DesignLayerProps) {
  const zones = mockup.zones.filter(z => z.view === view);
  const effect = markingEffect(markingId, productHex);
  return <div className="absolute inset-0" data-id="element-35" data-mp="1ci518775mlri">
      {zones.map(z => {
      const active = interactive && z.id === activeZoneId;
      const zoneEls = elements.filter(e => e.zoneId === z.id);
      return <div key={z.id} onPointerDown={interactive ? () => onZoneClick?.(z.id) : undefined} className={`absolute ${interactive ? active ? "outline-dashed outline-1 outline-ink/60" : "cursor-pointer outline-dashed outline-1 outline-ink/20 hover:outline-ink/50" : "overflow-hidden"}`} style={{
        left: `${z.x / 4}%`,
        top: `${z.y / 4}%`,
        width: `${z.w / 4}%`,
        height: `${z.h / 4}%`,
        containerType: "size"
      } as React.CSSProperties} data-id="element-36" data-mp="oqpwy8vthudm">
            {active && zoneEls.length === 0 && <span className="pointer-events-none absolute inset-0 flex items-center justify-center p-1 text-center text-[10px] font-bold uppercase tracking-wide text-ink/50" data-id="element-37" data-mp="18d4m5zbx8yyw">
                {z.name}
              </span>}
            <div className="absolute inset-0" style={effect} data-id="element-38" data-mp="udv8p7f3oiym">
              {zoneEls.map(el => <DesignElementView key={el.id} el={el} interactive={interactive} selected={interactive && el.id === selectedId} onSelect={() => onSelect?.(el)} onLive={patch => onLive?.(el.id, patch)} onCommit={patch => onCommit?.(el.id, patch)} onGestureStart={onGestureStart} onGestureEnd={onGestureEnd} onDelete={() => onDelete?.(el.id)} data-id="element-39" data-mp="pes41o318er6" />)}
            </div>
          </div>;
    })}
    </div>;
}